<header class="navbar">
	<nav class="navbar-content" aria-label="Navegación principal">
		<a class="mvl-logo" [href]="rootURL" aria-label="Ir a la página principal">
			<img class="logo-mobile topbar-logo" src="/svg/mvl-isologo.svg" alt="MVL" />
			<img
				class="logo-desktop topbar-logo"
				src="/logo-vic-lopez.png"
				alt="Vicente López"
			/>
		</a>
	</nav>
</header>
